import { useFetchAppCollectionsQuery } from '../redux/api/appMarket-api-slice';
import { GlobalAppCollection } from '../models/app';
import { AppCollectionScenarios } from '../models/enums';
import { useMemo } from 'react';

export const useCollectionsRelatedToApp = (appId: Uuid, scenario: AppCollectionScenarios = AppCollectionScenarios.AppDetails) : GlobalAppCollection[] => {
  const { data: appCollections, isLoading: appCollectionsLoading } = useFetchAppCollectionsQuery({scenario:AppCollectionScenarios.AppDetails,appId:appId});
  return useMemo(() => {
    if (!appCollectionsLoading && appCollections?.ids.length) {
      return (Object.values(appCollections.entities) as GlobalAppCollection[])
    } else return [];
  }, [appCollections, appCollectionsLoading]);
};
